import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { Szme037aRequest, Sgkd051aResponse, Sgkd051aService } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd051aService {
  /** 指定された売掛金の詳細情報情報取得のSubject */
  private _contractorDetail$ = new Subject<Sgkd051aResponse>();

  /**
   * 指定された売掛金の詳細情報情報取得のobservable提供
   *
   * @readonly
   * @memberof UsedSgkd051aService
   */
  get contractorValueChanges(): Observable<Sgkd051aResponse> {
    return this._contractorDetail$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKD051AService} sGKD051AService
   * @param {ApiCommonService} apiCommonService
   * @memberof InitialInfoService
   */
  constructor(private sgkd051aService: Sgkd051aService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   *売掛金の詳細情報情報取得API呼び出し
   *
   * @param {*} value
   * @memberof UsedSzme037aService
   */
  searchContractor(value: any, cdtmnyNo: string, cdtmnyRrkno: string): Observable<Sgkd051aResponse> {
    // リクエスト情報生成
    let request: Szme037aRequest = {
      cdtmnyNo: cdtmnyNo,
      cdtmnyRrkno: cdtmnyRrkno
    };
    return this.sgkd051aService.c17RSZME037APost(this.apiCommonService.setRequestCommon(<any>request),'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._contractorDetail$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD051A');
          return throwError(err.message);
        }));
  }
}
